<!-- 子组件 -->
<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="上级分类名称" v-if="oldlist.categoryName">
        <span>{{ oldlist.categoryName }}</span>
      </a-form-model-item>
      <a-form-model-item label="分类名称" prop="categoryName">
        <a-input v-model="form.categoryName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1"> 正常 </a-radio-button>
          <a-radio-button :value="0"> 下线 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="类目展示图" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic ? [form.pic] : []"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="类目图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon ? [form.icon] : []"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/declaration/declarationClassification'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: undefined,
        categoryName: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        grade: 1,
        parentId: 0,
        status: 1,
        sort: 99,
      },
      open: false,
      showLoading: false,
      oldlist: {},
      rules: {
        categoryName: [{ required: true, message: '请输入的分类名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        icon: [{ required: true, message: '请类目图片', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onClose() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    reset() {
      this.form = {
        id: undefined,
        categoryName: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        grade: 1,
        parentId: 0,
        status: 1,
        sort: 99,
      }
    },
    handleAdd(row) {
      this.reset()
      this.open = true
      if (row) {
        this.oldlist = row
        if (row.grade == 1) {
          this.form.grade = 2
          this.form.parentId = row.categoryId
          this.formTitle = '添加二级商品分类'
          this.$emit('level-change', 'inner')
        } else {
          this.form.grade = 3
          this.form.parentId = row.categoryId
          this.formTitle = '添加三级商品分类'
          this.$emit('level-change', 'grand')
        }
      } else {
        this.oldlist = {}
        this.form.grade = 1
        this.formTitle = '添加一级商品分类'
        this.$emit('level-change', 'parent')
      }
    },
    handleUpdate(row, ids, level) {
      this.reset()
      const postId = row ? row.categoryId : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改商品分类'
        this.$emit('level-change', level)
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          const action = this.form.categoryId ? putObj(this.form) : addObj(this.form)
          action
            .then(() => {
              this.$message.success(this.form.categoryId ? '修改成功' : '新增成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, ['请检查表单填写'])
          })
        }
      })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
  },
}
</script>
